import {
  Component,
  OnInit,
  Compiler,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';
import { ThisReceiver } from '@angular/compiler';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  templateUrl: 'managerRatingSection.component.html',
  styleUrls: ['managerRatingSection.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ManagerRatingSectionComponent implements OnInit {
  @ViewChild('closeModel1', { read: ElementRef }) closeModel1: ElementRef;
  @ViewChild('closeModel2', { read: ElementRef }) closeModel2: ElementRef;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  loading: boolean = false;
  users: any = {};
  behavioralSkillRatingForm: any;
  functionalSkillRatingForm: any;
  config: any;
  fetchData: any[] = [];
  submitted = false;
  loginImageURL: any = '';
  baseURL: any = null;
  loginUserName: any = '';
  showHideModel: boolean = true;
  skillData: any[] = [];
  behSkillList: any[] = [];
  //Add users form fields
  userUpdatedId: Number = 0;
  selectedPositionId: Number = 0;
  skillRatingFromDate: any;
  towerId: number = 0;
  userRole: number = 0;
  skillRatingData: any[] = [];
  fullFunRatingList: any;
  fullBehRatingList: any;
  convertedData: any[][] = [];
  dateRanges: any[] = [1];
  allPositions: any = [];
  isenabledMFun: any = 'false';
  isenabledMBeh: any = 'false';
  positionList: any = [];
  CometencyLevelCount: any = 0;
  isMFRatingSubmitted: any = 0;
  isMBRatingSubmitted: any = 0;
  isBShow: any = true;
  isFShow: any = true;
  isShowCompForm: any = true;
  lastSubmittedDate: any = [];
  diffInDays: any = 0;
  ratingInDays: any = 60;
  active = 0;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private excelService: ExcelService,
    private commonService: CommonService,
    private common: Common,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout();
      return;
    }
    if (this.users && this.users.userData) {
      this.users = this.users.userData;
      if (this.users.userFullName) {
        this.loginUserName = this.users.userFullName;
        this.users.userFullName = this.users.userFullName.toLowerCase();
      } else {
        this.loginUserName = this.users.userName;
        this.users.userFullName = this.users.userName.toLowerCase();
      }
      if (
        !this.users.emailAddress ||
        this.users.emailAddress.trim().length == 0
      ) {
        this.users['emailAddress'] = this.users.email;
      }
      this.userRole = this.users.userRoll;
      this.towerId = this.users.towerId;
    }
    let currentDate = new Date();
    this.config = config;
    this.config.minDate = {
      year: currentDate.getFullYear() - 1,
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    };
    this.config.markDisabled = false;
    this.loginImageURL = this.appConfig.getDefaultImgURL();
    this.fetchSkillsData();
    this.getAllBehSkills();
  }

  ngOnInit() {
    this.fetchSkillRatingData();
    if (this.userRole == 1) {
      this.fetchUserData(null, null);
    } else if (this.userRole == 5 || !this.userRole) {
      this.fetchUserData(this.users.userId, this.towerId);
    } else {
      this.fetchUserData(null, this.towerId);
    }
    this.initalizeFunSkillForm();
    this.initalizeBehSkillForm();
    this.fetchPositions();
  }

  // initalize Functional Skill Form
  private initalizeFunSkillForm() {
    this.userUpdatedId = 0;
    this.selectedPositionId = 0;
    let groupForm = {
      skillRatingFromDate: ['', Validators.required],
      skillRatingToDate: ['', Validators.required],
    };
    if (this.skillData && this.skillData.length > 0) {
      for (let i = 0; i < this.skillData.length; i++) {
        groupForm[this.skillData[i].skillName] = new FormControl('1');
      }
    }
    this.functionalSkillRatingForm = this.formBuilder.group(groupForm);
  }

  //Initalize Behavioral Skill Form
  private initalizeBehSkillForm() {
    this.userUpdatedId = 0;
    this.selectedPositionId = 0;
    let groupForm = {
      skillRatingFromDate: ['', Validators.required],
      skillRatingToDate: ['', Validators.required],
    };

    if (this.behSkillList && this.behSkillList.length > 0) {
      for (let i = 0; i < this.behSkillList.length; i++) {
        groupForm[this.behSkillList[i].skillName] = new FormControl('1');
      }
    }
    this.behavioralSkillRatingForm = this.formBuilder.group(groupForm);
  }

  // /fetch user information data
  private fetchSkillRatingData() {
    this.skillRatingData = [];
    this.commonService
      .fetchSkillRatingData()
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            this.skillRatingData = data;
          } else {
            localStorage.setItem('errorMsg', 'Data Not Found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Behavioral Skill Details From Skill Master
  private getAllBehSkills() {
    this.loading = true;
    this.commonService
      .postAllBehSkills(this.towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.behSkillList = data;
            this.initalizeBehSkillForm();
          } else {
            this.loading = false;
            localStorage.setItem(
              'errorMsg',
              'Behavioral Skills Data Not Found'
            );
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Behavioral Skill Details From Skill Master
  private getAllBehSkillsForUser(userId) {
    this.loading = true;
    this.isShowCompForm = true;
    this.commonService
      .getAllBehRatingsForUser(this.towerId, userId)
      .pipe(first())
      .subscribe(
        (data) => {
          console.log('Beh comp list of user', data);
          this.loading = false;
          if (data && data.length > 0) {
            this.fullBehRatingList = data;
            this.convertData(false);
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Behavioral Skill Details From Skill Master
  private getAllFunSkillsForUser(userId) {
    this.loading = true;
    this.isShowCompForm = true;
    this.commonService
      .getAllFunRatingsForUser(this.towerId, userId)
      .pipe(first())
      .subscribe(
        (data) => {
          //this.userId
          this.loading = false;
          if (data && data.length > 0) {
            this.fullFunRatingList = data;
            this.convertData(true);
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private convertData(isFunctional) {
    console.log('convert data');
    this.active = 0;
    var ratings1;
    if (isFunctional) ratings1 = this.fullFunRatingList;
    else ratings1 = this.fullBehRatingList;

    var ratings2 = [];
    this.dateRanges = [1];
    this.lastSubmittedDate = [];
    let j = 0;
    let k = 1;
    console.log('List fullFunRatingList', this.fullFunRatingList);
    var tempStartDate = '';
    var tempEndDate = '';
    for (let dates = 0; dates < ratings1.length; dates++) {
      let newDateRange =
        this.formatDate(ratings1[dates].skillRatingFromDate) +
        ' - ' +
        this.formatDate(ratings1[dates].skillRatingToDate);

      if (this.dateRanges.indexOf(newDateRange) === -1) {
        this.dateRanges.push(newDateRange);
      }
    }
    for (let i = 0; i < ratings1.length; i++) {
      var curIndex = this.getIndexOf(ratings2, ratings1[i].skillName);
      if (curIndex === -1) {
        ratings2[j] = [];
        ratings2[j][0] = ratings1[i].skillName;
        curIndex = j;
        j++;
        for (
          let dateArray = 1;
          dateArray < this.dateRanges.length;
          dateArray++
        ) {
          ratings2[curIndex].push(ratings1[i].skillScore);
        }
      }

      let fSubmittedDate = ratings1[i].createDate; //this.formatDate();
      if (this.lastSubmittedDate.indexOf(fSubmittedDate) === -1) {
        this.lastSubmittedDate.push(fSubmittedDate);
      }
    }
    console.log('ratings2', ratings2);
    this.convertedData = ratings2;
    setTimeout(() => {
      this.active = 0;
    }, 1000);
    this.checkLastSubmitDate();
  }
  /**
   * Check supervisor can fill competency again or not
   */
  checkLastSubmitDate() {
    if (this.lastSubmittedDate.length) {
      const lastSubmittedDate =
        this.lastSubmittedDate[this.lastSubmittedDate.length - 1]; // '2020-11-25';
      const date1 = new Date(lastSubmittedDate);
      const cDate = new Date();
      var Difference_In_Time = cDate.getTime() - date1.getTime();
      // To calculate the no. of days between two dates
      var Difference_In_Days = Math.floor(
        Difference_In_Time / (1000 * 3600 * 24)
      );
      this.diffInDays = Difference_In_Days;
      this.isShowCompForm = true;
      if (Difference_In_Days < this.ratingInDays) {
        this.isShowCompForm = false;
      }
      console.log('Difference_In_Days', Difference_In_Days);
    }
  }
  private getIndexOf(arr, item) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] && arr[i][0] === item) return i;
    }
    return -1;
  }

  private formatDate(dateStr) {
    return (
      new Date(dateStr).getDate() +
      '/' +
      (new Date(dateStr).getMonth() + 1) +
      '/' +
      new Date(dateStr).getFullYear()
    );
  }

  // /fetch user information data
  private fetchPositions() {
    // var towerId = JSON.parse(localStorage.user).userData.towerId;
    let towerId = null;
    this.commonService
      .getAllPositionInfo(towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.positionList = data;
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getPositionName(positionId) {
    for (let i = 0; i < this.positionList.length; i++) {
      if (this.positionList[i].positionId == positionId)
        return this.positionList[i].positionName;
    }
  }

  // edit user skill information data
  private onEditSubmit(userData, isFuntion) {
    this.active = 0;
    setTimeout(() => {
      $('.mat-ink-bar').css('width', '160px');
    }, 100);
    this.CometencyLevelCount = 0;
    this.fullBehRatingList = [];
    this.fullFunRatingList = [];
    this.convertedData = [];
    this.dateRanges = [1];
    if (isFuntion) this.getAllFunSkillsForUser(userData.userId);
    else this.getAllBehSkillsForUser(userData.userId);

    if (userData) {
      this.userUpdatedId = userData.userId;
      // this.selectedPositionId = userData.positionId;
      this.selectedPositionId = userData.nextPosition;

      this.isenabledMFun = userData.isenabledMFun;
      this.isenabledMBeh = userData.isenabledMBeh;

      if (userData.mBehRatings == 1) {
        this.isBShow = false;
      }
      if (userData.mFunRatings == 1) {
        this.isFShow = false;
      }

      let groupForm = {
        skillRatingFromDate: new FormControl(
          this.common.getJSONObj(userData.skillRatingFromDate)
        ),
        skillRatingToDate: new FormControl(
          this.common.getJSONObj(userData.skillRatingToDate)
        ), //TODO is this right
      };
      if (isFuntion) {
        // set value of functional skill  from
        let userSkill = userData.funUserSkill;
        if (this.skillData && this.skillData.length > 0) {
          for (let i = 0; i < this.skillData.length; i++) {
            if (userSkill && userSkill.length > 0) {
              for (let j = 0; j < userSkill.length; j++) {
                if (userSkill[j].skillId == this.skillData[i].skillId) {
                  groupForm[this.skillData[i].skillName] = new FormControl(
                    userSkill[j].skillLevel
                  );
                }
              }
            }
            if (!groupForm[this.skillData[i].skillName]) {
              groupForm[this.skillData[i].skillName] = new FormControl('1');
            }
          }
        }
        this.functionalSkillRatingForm = this.formBuilder.group(groupForm);
      } else {
        // set value of behavioral skill  from
        let userSkill = userData.behUserSkill;
        if (this.behSkillList && this.behSkillList.length > 0) {
          for (let i = 0; i < this.behSkillList.length; i++) {
            if (userSkill && userSkill.length > 0) {
              for (let j = 0; j < userSkill.length; j++) {
                if (userSkill[j].skillId == this.behSkillList[i].skillId) {
                  groupForm[this.behSkillList[i].skillName] = new FormControl(
                    userSkill[j].skillLevel
                  );
                }
              }
            }
            if (!groupForm[this.behSkillList[i].skillName]) {
              groupForm[this.behSkillList[i].skillName] = new FormControl('1');
            }
          }
        }
        this.behavioralSkillRatingForm = this.formBuilder.group(groupForm);
      }
      console.log('Skill Datatttttttt', this.skillData);
    }
  }

  //fetch skills data
  private fetchSkillsData() {
    this.commonService
      .postAllFunSkills(this.towerId)
      .pipe(first())
      .subscribe(
        //fetchSkill(s)Data
        (data) => {
          this.skillData = data;
          this.initalizeFunSkillForm();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //fetch user skills data
  private getAllNextPositions(userIds, towerId) {
    this.loading = true;
    this.commonService
      .getAllNextPositions(userIds, towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.allPositions = data;
          var that = this;
          setTimeout(function () {
            that.loading = false;
          }, 1000);
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // /fetch user information data
  private fetchUserData(userId, towerId) {
    this.loading = true;
    var userEmail = '';
    if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
      userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;

    this.commonService
      .fetchUserData(userId, towerId, userEmail)
      .pipe(first())
      .subscribe(
        (data) => {
          let userIds = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].userId) {
              userIds.push(data[i].userId);
            }
          }
          if (userIds.length > 0) {
            this.fetchData = data;
            // this.fetchUserFunctSkillsData(userIds, data);
          }

          console.log('this.fetchData', this.fetchData);
          this.getAllNextPositions(
            userIds,
            JSON.parse(localStorage.user).userData.towerId
          );
        },
        (error) => {
          localStorage.setItem('errorMsg', error);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //fetch user skills data
  private fetchUserBehSkillsData(userIds: any[], userData) {
    this.commonService
      .fetchAllBehSkills(userIds)
      .pipe(first())
      .subscribe(
        (data) => {
          for (let j = 0; j < userData.length; j++) {
            let userSkill = [];
            for (let i = 0; i < data.length; i++) {
              if (userData[j].userId == data[i].userId) {
                let skillLevel = data[i].skillLevel;
                let skillName = '';
                this.behSkillList.forEach((litem, index) => {
                  if (litem.skillId == data[i].skillId) {
                    skillName = litem.skillName;
                  }
                });
                userSkill.push({
                  skillId: data[i].skillId,
                  skillLevel: skillLevel,
                  skillName: skillName,
                });
              }
            }
            userData[j]['behUserSkill'] = userSkill;
          }
          this.fetchData = userData;
          this.categoriseLeaveUsers();
          this.countActiveAndInactiveUsers();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  //categorise leave users
  private categoriseLeaveUsers() {
    for (let i = 0; i < this.fetchData.length; i++) {
      if (this.fetchData[i].skillRatingToDate) {
        let currentDate = new Date();
        let userskillRatingToDate = new Date(
          this.fetchData[i].skillRatingToDate
        );
        if (currentDate > userskillRatingToDate) {
          this.fetchData[i]['leaveStyle'] = 'red';
        }
      }
    }
  }

  // validate resoucre leaving date should be equal or lessthen from current date
  private countActiveAndInactiveUsers() {
    for (let i = 0; i < this.fetchData.length; i++) {
      let isFound = false;
      //remove user from the list if having leave date less then current date
      let currentTime = this.common.getTime(new Date());
      if (this.fetchData[i].skillRatingToDate) {
        let leavingTime = this.common.getTime(
          this.fetchData[i].skillRatingToDate
        );
        if (currentTime > leavingTime) {
          isFound = true;
        }
      }
      if (isFound) {
        this.fetchData[i]['leaveUserCSS'] = 'leaveUserCSS';
      } else {
        this.fetchData[i]['leaveUserCSS'] = '';
      }
    }
  }

  // save user information
  private onSubmit(skillRatingForm, isFunctional) {
    if (isFunctional) {
      if (this.functionalSkillRatingForm.invalid) {
        this.submitted = true;
        return;
      }
    } else {
      if (this.behavioralSkillRatingForm.invalid) {
        this.submitted = true;
        return;
      }
    }
    let skillRatingData = this.setUserSkillData(
      skillRatingForm,
      this.userUpdatedId,
      isFunctional
    );
    let currentUserSkill = this.setUserCurrentSkillData(
      skillRatingForm,
      this.userUpdatedId,
      isFunctional
    );
    this.loading = true;
    this.commonService
      .saveSkillRatingData(
        skillRatingData,
        currentUserSkill,
        isFunctional,
        this.towerId
      )
      .pipe(first())
      .subscribe(
        (data) => {
          if (isFunctional) {
            this.isMFRatingSubmitted = 1;
            this.isFShow = false;
            this.getAllFunSkillsForUser(this.userUpdatedId);
            this.functionalSkillRatingForm.reset();
          } else {
            this.isMBRatingSubmitted = 1;
            this.getAllBehSkillsForUser(this.userUpdatedId);
            this.behavioralSkillRatingForm.reset();
            this.isBShow = false;
          }

          localStorage.setItem('errorMsg', data);
          this.closeModels();
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        },
        (error) => {
          console.log('error', error);
          this.loading = false;
          localStorage.setItem('errorMsg', 'Must Enter all the fields');
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //set user skill data
  private setUserSkillData(userFormDetails: any, userId: any, isFunctional) {
    let userSkillData = [];
    if (isFunctional) {
      for (let i = 0; i < this.skillData.length; i++) {
        console.log(
          'this.skillData[i].positionId',
          this.skillData[i].positionId
        );
        console.log('this.selectedPositionId', this.selectedPositionId);
        if (this.skillData[i].positionId != this.selectedPositionId) continue;
        console.log('reached1');
        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.skillData[i].skillId;
        skillObj['skillScore'] = this.getScoreBySkillName(
          userFormDetails[this.skillData[i].skillName]
        );
        skillObj['skillRatingBy'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['createDate'] = new Date();
        skillObj['ratedByRole'] = this.users.userRoll;
        userSkillData.push(skillObj);
      }
    } else {
      for (let i = 0; i < this.behSkillList.length; i++) {
        if (
          this.getScoreBySkillName(
            userFormDetails[this.behSkillList[i].skillName]
          ) === 0
        )
          continue;
        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.behSkillList[i].skillId;
        skillObj['skillScore'] = this.getScoreBySkillName(
          userFormDetails[this.behSkillList[i].skillName]
        );
        skillObj['skillRatingBy'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['createDate'] = new Date();
        skillObj['ratedByRole'] = this.users.userRoll;
        userSkillData.push(skillObj);
      }
    }

    console.log('userSkilldata', userSkillData);
    return userSkillData;
  }

  private getScoreBySkillName(skillName) {
    let score = 1;
    if (skillName && skillName.trim().length > 0) {
      for (let i = 0; i < this.skillRatingData.length; i++) {
        if (
          this.skillRatingData[i].ratingName.toLowerCase() ==
          skillName.toLowerCase()
        ) {
          score = this.skillRatingData[i].score;
          break;
        }
      }
    }
    return score;
  }
  //set user skill data
  private setUserCurrentSkillData(
    userFormDetails: any,
    userId: any,
    isFunctional
  ) {
    let userSkillData = [];
    console.log('userFormDetails', userFormDetails);
    if (isFunctional) {
      for (let i = 0; i < this.skillData.length; i++) {
        if (this.skillData[i].positionId != this.selectedPositionId) continue;

        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.skillData[i].skillId;
        skillObj['skillName'] = this.skillData[i].skillName;
        // skillObj["targetScore"] = this.skillData[i].targetScore;
        skillObj['skillLevel'] = Number(
          userFormDetails[this.skillData[i].skillName]
        );
        skillObj['createdByEmail'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['ratedByRole'] = Number(this.users.userRoll);

        userSkillData.push(skillObj);
      }
    } else {
      for (let i = 0; i < this.behSkillList.length; i++) {
        if (this.behSkillList[i].positionId != this.selectedPositionId)
          continue;

        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.behSkillList[i].skillId;
        skillObj['skillName'] = this.behSkillList[i].skillName;
        // skillObj["targetScore"] = this.behSkillList[i].targetScore;
        skillObj['skillLevel'] = Number(
          userFormDetails[this.behSkillList[i].skillName]
        );
        skillObj['createdByEmail'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['ratedByRole'] = Number(this.users.userRoll);
        userSkillData.push(skillObj);
      }
    }
    return userSkillData;
  }

  //save skills data
  private saveSkillsData(userSkillData) {
    this.commonService
      .saveSkillsData(userSkillData, this.users.emailAddress)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data != null) {
            this.functionalSkillRatingForm.reset(); //TODO: This is how to reset the form
            localStorage.setItem(
              'errorMsg',
              'User successfully added as a TR Nominee'
            );
            localStorage.setItem('isReload', 'true');
            this.commonService.showerror();
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', 'Must Enter all the fields');
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //set start date
  private setStartDate() {
    let currentDate = new Date();
    this.config.minDate = {
      year: currentDate.getFullYear() - 1,
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    };
  }

  //set end dates
  private setEndDate() {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    currentDate.setMonth(currentDate.getMonth() + 3);
    if (this.functionalSkillRatingForm.value.skillRatingFromDate) {
      var dd = currentDate.getDate();
      var mm = currentDate.getMonth();
      var yy = currentDate.getFullYear();
      this.config.minDate = { year: yy - 1, month: mm, day: dd };
    } else if (this.behavioralSkillRatingForm.value.skillRatingFromDate) {
      var dd = currentDate.getDate();
      var mm = currentDate.getMonth();
      var yy = currentDate.getFullYear();
      this.config.minDate = { year: yy - 1, month: mm, day: dd };
    } else {
      localStorage.setItem('errorMsg', 'Please select Start Date');
      this.commonService.showerror();
      return;
    }
  }

  //close dailog box
  private closeModels() {
    this.closeModel1.nativeElement.click();
    this.closeModel2.nativeElement.click();
    this.active = 0;
  }

  //forward to next section
  public gotoNextPage(e, routeURL) {
    this.router.navigate([routeURL]);
  }

  // logout and forward to login page
  private logout() {
    this.commonService.logout();
  }
  /**
   * For competency level count.
   * @param count
   */
  countFunCompLevel(count) {
    this.CometencyLevelCount++;
  }
}
